const Ratings = [
  { number: "1", background: "" },
  { number: "2", background: "" },
  { number: "3", background: "" },
  { number: "4", background: "" },
  { number: "5", background: "" },
];

export default Ratings;
